/**
 * Token工具类
 */

// Token存储键名

import { v4 as uuidv4 } from "uuid";
import CryptoJS from "crypto-js";
const TOKEN_KEY = "event_token";

/**
 * 获取Token
 * @returns {String|null}
 */
export function getToken() {
  if (typeof window !== "undefined") {
    return localStorage.getItem(TOKEN_KEY);
  }
  return null;
}

/**
 * 设置Token
 * @param {String} token Token值
 */
export function setToken(token) {
  if (typeof window !== "undefined") {
    localStorage.setItem(TOKEN_KEY, token);
  }
}

/**
 * 移除Token
 */
export function removeToken() {
  if (typeof window !== "undefined") {
    localStorage.removeItem(TOKEN_KEY);
  }
}

/**
 * 判断是否有Token
 * @returns {Boolean}
 */
export function hasToken() {
  return !!getToken();
}

export function getNonce() {
  const uuid = uuidv4();
  return uuid;
}

const appsecret = "0b50fb0329fc405b9456ad56bd74db7e";
export function generateSign(nonce, timestamp, body) {
  // 处理请求体：对象转为JSON字符串（保持与示例一致的格式）
  const bodyStr = typeof body === "object" ? JSON.stringify(body) : body;

  // 拼接加密前的字符串：请求ID + 时间戳 + 请求体
  const plainText = `${nonce}${timestamp}${bodyStr}`;

  // 使用 HmacSHA256 加密
  const hmac = CryptoJS.HmacSHA256(plainText, appsecret);

  return hmac.toString(CryptoJS.enc.Hex);
}
